import React, { useEffect, useState } from "react";

import Context from "./index";
import { toast } from "react-toastify";
import {
  alertError,
  alertSuccess,
} from "../../../../Shared/Utils/alertMessages.js";
import {
  errorDeleteingData,
  errorGettingData,
  errorInsertingData,
  errorUpdatingData,
  genericError,
  ItemCreated,
  ItemUpdated,
  successDeleted,
} from "../../../../Shared/Constants/index.jsx";

import { getJurisdictionsApi } from "../../../../Shared/Api/GetJurisdictions.js";
import { alertToastErrorFromResponse } from "../../../../Shared/Utils/errorUtils.js";
import { createJurisdictionApi } from "../Api/CreateJurisdiction.js";
import { deleteJurisdictionApi } from "../Api/DeleteJurisdiction.js";
import { updateJurisdictionApi } from "../Api/UpdateJurisdiction.js";
import { togleLoading } from "../../../../Shared/Utils/alertLoading.js";

const JurisdictionProvider = (props) => {
  const [tableData, setTableData] = useState([]);
  const [apiErrors, setApiErrors] = useState([]);
  const [item, setItem] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");

  const modalTogle = () => {
    setModal(!modal);
  };
  //List objects frokm db
  const fetchTableData = async (page, limit) => {
    setLoading(true);
    try {
      let response = await getJurisdictionsApi({
        search: searchTerm,
        page: page,
        limit: limit,
      });
      let data = response.data;
      if (response.result === "success") {
        setTableData(data.items); // Append new data
        setTotalRows(data.totalRows); // Append new data
      } else {
        setTableData([]); // Append new data
        setTotalRows(0); // Append new data
        alertToastErrorFromResponse(errorGettingData, response);
      }
    } catch (error) {
      alertToastErrorFromResponse(genericError, error);
    } finally {
      setLoading(false);
    }
  };

  //Create object
  const createItem = async (data) => {
    togleLoading(true);
    let response = await createJurisdictionApi(data);

    if (response?.result && response?.result == "success") {
      alertSuccess(ItemCreated);
      fetchTableData(currentPage, rowsPerPage);
      modalTogle();
      setApiErrors([]);
    } else {
      alertToastErrorFromResponse(errorInsertingData, response);
    }
    togleLoading(false);
  };

  //edit item
  const updateItem = async (data, id) => {
    togleLoading(true);
    let response = await updateJurisdictionApi(data, id);

    if (response?.result && response?.result == "success") {
      // Crear una nueva copia de tableData
      const updatedTableData = tableData.map(
        (elem) =>
          elem.id === id
            ? { ...elem, name: data.name, type: data.type } // Actualizar el elemento correspondiente
            : elem // Mantener el resto igual
      );

      setTableData(updatedTableData); // Actualizar el estado con un nuevo array
      alertSuccess(ItemUpdated);
      modalTogle();
      setApiErrors([]);
    } else {
      alertToastErrorFromResponse(errorUpdatingData, response);
    }
    togleLoading(false);
  };

  //delete item
  const deleteItem = async (id) => {
    togleLoading(true);
    let response = await deleteJurisdictionApi(id);

    if (response?.result && response?.result == "success") {
      const newdata = tableData.filter((elem) => {
        return id !== elem.id;
      });
      setTableData(newdata);
      alertSuccess(successDeleted);
      setApiErrors([]);
    } else {
      alertToastErrorFromResponse(errorDeleteingData, response);
    }
    togleLoading(false);
  };

  const handleEdit = async (row) => {
    let editObject = tableData.find((e) => e.id === row.id);
    setItem(editObject);
    setApiErrors([]);
  };

  return (
    <Context.Provider
      value={{
        ...props,
        tableData,
        createItem,
        updateItem,
        deleteItem,
        fetchTableData,
        setCurrentPage,
        setRowsPerPage,
        setLoading,
        apiErrors,
        modalTogle,
        modal,
        setItem,
        item,
        loading,
        currentPage,
        totalRows,
        handleEdit,
        rowsPerPage,
        searchTerm,
        setSearchTerm,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};
export default JurisdictionProvider;
